import React from 'react';
import * as S from './BusBerth.styles';
import SeatWithTooltip from '../../../../../../stories/core-components/SeatWithTooltip/SeatWithTooltip';

import Icon from '../../../../../../stories/core-components/IconsSelector';

type BusBerthProps = {
  berthtitle?: string;
  isSleeper?: boolean;
  isSeater?: boolean;
  data: any;
  onSeatClick: Function;
  selectedSeatLayoutInfo: object;
  showIcon?: boolean;
  showIconOnly?:boolean;
};
const BusBerth = (props: BusBerthProps) => {
  const {berthtitle, data, onSeatClick, selectedSeatLayoutInfo, showIcon,showIconOnly} = props;
  return (
    <S.BusOutline>

      {(showIconOnly && (
              <aside className="header">
              <p className="iconWrap">
             <Icon name="SteeringWheelIcon" />
           </p>
     
         </aside>
   
      )) || (
        <aside className="header">
        <span>{berthtitle}</span>
      {showIcon?    <p className="iconWrap">
          <Icon name="SteeringWheelIcon" />
        </p> :null}
      </aside>
  
      )}

      <aside className="busContent">
        {<div>{getSeatViewData(data, onSeatClick, selectedSeatLayoutInfo)}</div>}
      </aside>
    </S.BusOutline>
  );
};

export default BusBerth;
function getSeatViewData(data, cb, selectedSeatLayoutInfo) {
  let viewData = [];
  for (let i in data) {
    const {
      bid,
      sn,
      deck,
      isSleeper,
      isAvailable,
      lseat,
      ffs,
      fms,
      bf,
      rn,
      cn,
      rrn,
      acf,
      orientation,
      sf_res,
    } = data[i];
    const discount = 0; // TODO:-will come in seat layout data after read deal data integration
    const {selectedPrice} = selectedSeatLayoutInfo;
    const selected =
      selectedSeatLayoutInfo.selectedSeats[deck] &&
      selectedSeatLayoutInfo.selectedSeats[deck].indexOf(sn) !== -1;

    const disbaled = selectedPrice.indexOf(-1) === -1 && selectedPrice.indexOf(bf) === -1;
    viewData.push(
      <SeatWithTooltip
        key={i + data[i].route_id + data[i].sn}
        sleepericon={data[i].isSleeper}
        seatericon={!data[i].isSleeper}
        seatnumber={data[i].sn}
        seatprice={`₹${data[i].bf}`}
        styleProps={{top: `${data[i].top}`, left: `${data[i].left}`}}
        verticalSleeper={orientation === 'vertical'}
        onSeatClick={() => {
          if (isAvailable) {
            cb({
              bid,
              sn,
              deck,
              priceAfterDiscount: bf - discount,
              priceWithoutDiscount: bf,
              discount: discount,
            });
          }
        }}
        iconName={(() => {
          let name = '';
          if (sf_res) {
            name = isSleeper ? 'BusSleeperBlockedIcon' : 'BusSeatBlockedIcon';
          } else {
            if (isAvailable && (!disbaled || selected)) {
              if (selected) {
                if (lseat) {
                  name = isSleeper ? 'BusSleeperSelectedIcon' : 'BusSeatGreenIcon';
                } else {
                  name = isSleeper ? 'BusSleeperSelectedIcon' : 'BusSeatGreenIcon';
                }
              } else {
                if (lseat) {
                  name = isSleeper ? 'BusSleeperLadiesIcon' : 'BusSeatLadiesIcon';
                } else {
                  name = isSleeper ? 'BusSleeperIcon' : 'BusSeatIcon';
                }
              }
            } else {
              if (lseat) {
                name = isSleeper ? 'BusSleeperLadiesBlockedIcon' : 'BusSeatLadiesBlockedIcon';
              } else {
              name = isSleeper ? 'BusSleeperBookedIcon' : 'BusSeatBookedIcon';
              }
            }
          }
          return name;
        })()}
      />,
    );
  }

  return viewData;
}
